export function TrustSection() {
  const testimonials = [
    {
      name: '김철수',
      role: '부산 소재 원양어선 선장',
      content: '이전에는 부산 지역 업체만 알고 거래했는데, 해상마켓을 통해 보령의 우수한 제조업체를 발견했습니다. 품질도 좋고 가격도 합리적이어서 매우 만족합니다.',
      rating: 5,
      avatar: 'ri-user-line',
    },
    {
      name: '이영희',
      role: '목포 소재 연근해어선 선주',
      content: '중간 유통을 거치지 않고 제조업체와 직접 거래하니 비용이 30% 이상 절감되었습니다. 전문가 상담도 큰 도움이 되었어요.',
      rating: 5,
      avatar: 'ri-user-3-line',
    },
    {
      name: '박민수',
      role: '인천 소재 어선 기관장',
      content: '기관물품을 구매할 때마다 여러 업체를 일일이 연락하는 게 번거로웠는데, 이제는 한 곳에서 비교하고 주문할 수 있어 정말 편리합니다.',
      rating: 5,
      avatar: 'ri-user-2-line',
    },
  ];

  const stats = [
    { value: '98%', label: '고객 만족도', icon: 'ri-emotion-happy-line' },
    { value: '30%', label: '평균 비용 절감', icon: 'ri-price-tag-3-line' },
    { value: '24시간', label: '평균 응답 시간', icon: 'ri-time-line' },
    { value: '5,000+', label: '누적 거래 건수', icon: 'ri-shopping-cart-line' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* 통계 섹션 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-ocean-50 to-marine-50 rounded-xl p-6 text-center border border-ocean-100"
            >
              <div className="w-12 h-12 bg-ocean-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-white text-xl`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* 고객 후기 섹션 */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            고객 후기
          </h2>
          <p className="text-gray-600">
            실제 선장·선주님들의 생생한 이용 후기를 확인하세요
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed text-sm">
                "{testimonial.content}"
              </p>

              <div className="flex items-center">
                <div className="w-12 h-12 bg-ocean-100 rounded-full flex items-center justify-center mr-4">
                  <i className={`${testimonial.avatar} text-ocean-600 text-xl`}></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
